import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  inventory: [],
  loading: false,
  loaded: false,
  error: null,
};

const addeparInventorySlice = createSlice({
  name: "addeparInventory",
  initialState,
  reducers: {
    setAddeparInventoryLoading: (state, action) => {
      state.loading = action.payload;
      if (action.payload) state.error = null;
    },
    setAddeparInventory: (state, action) => {
      state.inventory = Array.isArray(action.payload) ? action.payload : [];
      state.loading = false;
      state.loaded = true;
      state.error = null;
    },
    setAddeparInventoryError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.loaded = true;
    },
    updateAddeparInventoryItem: (state, action) => {
      const updated = action.payload || {};
      const addeparInventoryId = updated.addeparInventoryId;
      const index = state.inventory.findIndex(
        (row) => String(row.addeparInventoryId) === String(addeparInventoryId)
      );
      if (index === -1) return;
      state.inventory[index] = {
        ...state.inventory[index],
        ...updated,
      };
    },
  },
});

export const {
  setAddeparInventoryLoading,
  setAddeparInventory,
  setAddeparInventoryError,
  updateAddeparInventoryItem,
} = addeparInventorySlice.actions;

export const selectAddeparInventory = (state) =>
  state.addeparInventory?.inventory || [];
export const selectAddeparInventoryLoading = (state) =>
  state.addeparInventory?.loading || false;
export const selectAddeparInventoryLoaded = (state) =>
  state.addeparInventory?.loaded || false;
export const selectAddeparInventoryError = (state) =>
  state.addeparInventory?.error || null;
export const selectAddeparPendingCount = (state) =>
  (state.addeparInventory?.inventory || []).filter(
    (row) => row?.status === "PENDING"
  ).length;

export default addeparInventorySlice.reducer;
